import React from 'react';

import { getExternalBasePath } from 'config/EnvironmentConfig';
import { ReactComponent as CompletedCheckMark } from 'assets/completedcheckmark.svg';
import DeceasedName from 'components/layouts/DeathNotification/DeathNotificationBody/steps/DeceasedDetails/DeceasedName/DeceasedName';
import DeceasedInfo from 'components/layouts/DeathNotification/DeathNotificationBody/steps/DeceasedDetails/DeceasedInfo/DeceasedInfo';
import DocumentUpload from 'components/layouts/DeathNotification/DeathNotificationBody/steps/DocumentUpload/DocumentUpload';
import PersonalInfo from 'components/layouts/DeathNotification/DeathNotificationBody/steps/PersonalDetails/PersonalInfo/PersonalInfo';
import PersonalRelations from 'components/layouts/DeathNotification/DeathNotificationBody/steps/PersonalDetails/PersonalRelations/PersonalRelations';
import ReviewSubmit from 'components/layouts/DeathNotification/DeathNotificationBody/steps/ReviewSubmit/ReviewSubmit';
import DeathNotificationTermsAndConditions from 'components/layouts/DeathNotification/DeathNotificationBody/steps/DeathNotificationTermsAndConditions/DeathNotificationTermsAndConditions';
import DeathNotificationConfirmation from 'components/layouts/DeathNotification/DeathNotificationBody/steps/DeathNotificationConfirmation/DeathNotificationConfirmation';

export const noBackButtonList = [7]

export const noSidePanelList = [5]

export const progressBarSteps = [
  { name: 'Deceased Details', stepValues: [0, 1] },
  { name: 'Document Upload', stepValues: [2] },
  { name: 'Personal Details', stepValues: [3, 4] },
  { name: 'Terms & Conditions', stepValues: [5] },
  { name: 'Review & Submit', stepValues: [6] }
];

export const listSteps = [
  { name:'DeceasedName',
    component: <DeceasedName/>,
    title: 'Please tell us who passed away.',
    onBackClickURL: getExternalBasePath() + '/personal-investing/resources/planning/life-events/inherited-account/death-notification.html',
    openParent: true,
    showFooter: true,
    analyticsPageName: 'DeceasedDetailsName'
  },
  {
    name:'DeceasedInfo',
    component: <DeceasedInfo/>,
    title: 'What additional information can you share?',
    showFooter: true,
    analyticsPageName: 'DeceasedDetailsAdditionalInfo'
  },
  {
    name:'DocumentUpload',
    component: <DocumentUpload/>,
    title: 'Do you have a copy of the death certificate?',
    showFooter: true,
    analyticsPageName: 'DocumentUpload'
  },
  {
    name:'PersonalInfo',
    component: <PersonalInfo/>,
    title:'Please tell us about yourself.',
    showFooter: true,
    analyticsPageName: 'PersonalDetails'
  },
  {
    name:'PersonalRelations',
    component: <PersonalRelations/>,
    title:'What is your relationship to the deceased?',
    showFooter: true,
    analyticsPageName: 'PersonalDetailsRelationship'
  },
  {
    name: 'DeathNotificationTermsAndConditions',
    component: <DeathNotificationTermsAndConditions/>,
    title: 'Terms & Conditions',
    continueButtonText: 'I agree',
    showFooter: true,
    analyticsPageName: 'TermsConditions'
  },
  {
    name: 'ReviewSubmit',
    component: <ReviewSubmit/>,
    title: 'Review & Submit',
    continueButtonText: 'Submit',
    showFooter: false,
    analyticsPageName: 'ReviewSubmit'
  },
  {
    name:'DeathNotificationConfirmation',
    component: <DeathNotificationConfirmation/>,
    title:'Thank you for submitting a death notification. Your case number is ',
    continueButtonText:'Done',
    openParent: true,
    onContinueClickURL: 'https://www.troweprice.com/personal-investing/resources/planning/life-events/inherited-account.html',
    icon: <CompletedCheckMark/>,
    showFooter: true,
    analyticsPageName: 'DeathNotificationConfirmation'
  },
];

export const lrnLifeEvents = '2576813';